import {regReducer} from '../../core';
import * as actions from './actions';
import * as p from './statePaths';
import * as r from 'ramda';
import * as s from './selectors';
import {
    alternateHistory,
    createFormData,
    getIngredientsGroupOrThrow,
    ingredientsFromQueryString,
} from './functions';

function increment(count) {
    return count + 1;
}

function decrement(count) {
    return count - 1;
}

function ingredientCountAction(action, state, ingredient) {
    ingredient.count = action(ingredient.count || 0);
    const targetGroup = getIngredientsGroupOrThrow(
        ingredient,
        s.ingredientGroups(state)
    );
    r.assocPath(
        ['ingredients', targetGroup.ingredients.indexOf(ingredient)],
        Object.assign({}, ingredient),
        targetGroup
    );

    const newState = Object.assign({}, state);
    alternateHistory(s.selectedIngredients(newState));

    return newState;
}

regReducer(actions.ACTION_INIT, (state, {payload}) => {
    const allIngredients = s.allIngredients({
        productCustomization: payload.initialState,
    });
    const selectedIngredients = ingredientsFromQueryString();
    allIngredients.forEach((ingredient) => {
        if (selectedIngredients[ingredient.code]) {
            ingredient.count = selectedIngredients[ingredient.code];
        }
    });
    return r.assocPath(p.component, payload.initialState, state);
});

regReducer(actions.ADD_INGREDIENT, (state, {payload}) => {
    return ingredientCountAction(increment, state, payload.ingredient);
});

regReducer(actions.REMOVE_INGREDIENT, (state, {payload}) => {
    return ingredientCountAction(decrement, state, payload.ingredient);
});

regReducer(actions.UNPACK_GROUP, (state, {payload}) => {
    const groups = s.ingredientGroups(state);
    const groupToCollapse = groups.filter((group) => !group.collapsed).shift();

    if (groupToCollapse) {
        state = r.assocPath(
            [
                ...p.ingredientGroups,
                groups.indexOf(groupToCollapse),
                'collapsed',
            ],
            true,
            state
        );
    }

    return r.assocPath(
        [...p.ingredientGroups, groups.indexOf(payload.group), 'collapsed'],
        false,
        state
    );
});

regReducer(actions.COLLAPSE_GROUP, (state, {payload}) => {
    return r.assocPath(
        [
            ...p.ingredientGroups,
            s.ingredientGroups(state).indexOf(payload.group),
            'collapsed',
        ],
        true,
        state
    );
});

regReducer(actions.FINISH, (state) => {
    document.querySelector('main.main').classList.add('loader');
    const formData = createFormData(state);
    $.post({
        url: s.submitUrl(state),
        data: formData,
    })
        .then((response) => {
            if (response && response.location) {
                window.location.href = response.location;
            }
        })
        .catch((error) => console.log(error));
});
